// extracted by mini-css-extract-plugin
export default {"input":"k6-z","button":"l6-z","selected":"m6-z","unavailable":"n6-z","oos":"o6-z","image":"p6-z","paperCutDisabledOverlay":"q6-z"};